import { render, staticRenderFns } from "./vPuestosVista.vue?vue&type=template&id=595a5ccd&scoped=true&"
import script from "./vPuestosVista.vue?vue&type=script&lang=js&"
export * from "./vPuestosVista.vue?vue&type=script&lang=js&"
import style0 from "./vPuestosVista.vue?vue&type=style&index=0&id=595a5ccd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595a5ccd",
  null
  
)

export default component.exports